module.exports = __webpack_public_path__ + "media/theme/icon__stock--in-ff302812.png";